<template>
  <div class="header">
    <div class="logo">
      <!-- <img @click="goIndexPage()" src="@/assets/image/logo.png" /> -->
      <div style="font-size:22px;text-align:left;margin-left:14px;margin-top:14px;color: black;">
        实景GIS三维空间漫游
      </div>
    </div>
    <div class="muenu_open" @click="mbOpenMenu()">
      <img src="@/assets/pageImg/more.png" alt="">
    </div>
    <div class="toIndex">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <!-- <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        router
        @select="handleSelect"
      > -->
        <el-menu-item v-for="(item, index) in menuArray" :index="item.path" @mouseover="onMenuMouseenter(index)"
          @mouseleave="onMenuMouseout()">{{ item.name }}</el-menu-item>
      </el-menu>

      <div class="product_box" v-if="productShow" @mouseover="onMenuMouseenter(1)" @mouseleave="onMenuMouseout()">
        <div class="p_item">
          <div class="p_title">
            <img src="@/assets/pageImg/icon13.png" alt="">
            <span>云展工具</span>
          </div>
          <div class="p_box">
            <img src="@/assets/pageImg/icon5.png" alt="">
            <span>3D漫游互动工具</span>
          </div>
        </div>
        <hr class="p_hr" />
        <div class="p_item">
          <div class="p_title">
            <img src="@/assets/pageImg/icon12.png" alt="">
            <span>趣致服务</span>
          </div>
          <div class="p_box">
            <img src="@/assets/pageImg/icon14.png" alt="">
            <span>创意定制合作</span>
          </div>
        </div>
      </div>

      <div class="about_box" v-if="aboutShow" @mouseover="onMenuMouseenter(3)" @mouseleave="onMenuMouseout()">
        <ul class="a_ul">
          <li class="a_li">企业介绍</li>
          <li class="a_li">行业资讯</li>
          <li class="a_li last_li">联系我们</li>
        </ul>
      </div>

    </div>

    <transition class="animate__animated animate__faster"
      :class="[{ animate__fadeInRight: isShowMenu }, { animate__fadeOutRight: !isShowMenu }]">
      <div class="mb_menu_top" v-show="isShowMenu">
        <el-menu :default-active="activeIndex" class="el-menu-demo" router>
          <MenuChildren v-for="item in menuArray" :index="item.path" :menu="item">
          </MenuChildren>
        </el-menu>
      </div>
    </transition>

    <div class="admin" v-if="!showContact">
      <div class="userinfo">
        <div class="flex" @mouseenter="openPop" @mouseleave="closePop" v-if="userData != null">
          <div class="img">
            <img v-if="userData.avatar != null" :src="baseUrl + userData.avatar" alt="" srcset="" />
            <img v-else src="@/assets/image/avatar.png" alt="">
          </div>
          <div class="username">
            <div class="name" style="font-weight: bold;">{{ userData.nickname }}</div>
            <div class="vip">
              <div class="type">
                <span v-if="userData.is_vip != 0">专业用户</span>
                <span class="ordinaryUser" v-else>普通用户</span>
              </div>
              <div class="img" v-if="userData.is_vip != 0">
                <img src="@/assets/image/V1.png" alt="" srcset="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="professionalShow" @mouseenter="openPop" @mouseleave="closePop">
          <professional :userMsg="userData"></professional>
        </div>
      </div>
      <div class="staging">
        <el-button color="#3160eb" @click="goWork">工作台</el-button>
      </div>
      <div class="SystemMsg" @mouseleave="onMouseleave">
        <el-badge v-model:is-dot="isDot" class="badge_box">
          <el-button @click="goMsg" @mouseenter="onMouseenter">系统消息</el-button>
        </el-badge>
        <div class="msg_box" @mouseleave="onMouseleave" v-if="noReadMsgList.length > 0 && msgListShow">
          <ul class="m_ul">
            <li class="u_item">{{ noReadMsgList[0].createtime }} &nbsp; {{ noReadMsgList[0].title }}</li>
            <li class="u_item" v-if="noReadMsgList.length > 2 && msgListShow">{{ noReadMsgList[1].createtime }} &nbsp;
              {{ noReadMsgList[1].title }}</li>
          </ul>
          <p class="m_more" @click="goMsg">更多>></p>
        </div>
      </div>
    </div>

    <div class="contact_box" v-if="showContact">
      <div class="c_phone">
        <img class="c_icon" src="@/assets/image/contact.png" alt="">
        <span class="c_num">0757-86220035</span>
      </div>
      <el-button color="#3160eb" @click="this.$router.push('/project')" v-if="false">
        <img class="c_btn_icon" src="@/assets/image/user.png" alt="">
        注册/登录
      </el-button>
    </div>

  </div>
</template>

<style lang="scss">
@import "@/assets/css/icon.css";
@import '@/assets/css/index/index.scss';
</style>

<script>
import { inject } from 'vue';
import { Monitor, CreditCard, QuestionFilled } from '@element-plus/icons-vue';
import professional from '@/components/Professional.vue';
import Capacity from '@/components/capacity/capacity.vue';
import { getNoReadMessageAPI, getuserinfo } from '@/api/api';
import MenuChildren from './menuChildren.vue';
export default {
  components: {
    professional, Monitor, CreditCard, QuestionFilled, Capacity, MenuChildren,
  },
  props: ['refreshMsg', 'msgList', 'userMsg'],
  inject: ['user_data'],
  data() {
    return {
      baseUrl: inject('global').baseUrl,
      baseName: inject('global').name,
      professionalShow: false,
      isShow: false,
      noReadMsgList: [],
      msgListShow: false,
      isDot: false,
      userData: null,
      showContact: false,
      menuArray: [],
      productShow: false,
      aboutShow: false,
      dropDown: null,
      activeIndex: 'null',
      isShowMenu: false,
      userDropDown: null,
    }
  },
  methods: {
    openPop() {  // 打开弹窗
      this.professionalShow = true;
      clearTimeout(this.userDropDown);
    },
    closePop() { // 关闭弹窗
      let self = this;
      this.userDropDown = setTimeout(function () {
        self.professionalShow = false
      }, 100)
    },
    goMsg() {  // 跳转到信息页
      this.$router.push('/Msg');
    },
    goWork() { // 跳转到工作页
      this.$router.push('/project');
    },
    goIndexPage() {  // 跳转到首页
      this.$router.push('/homePage');
    },
    /** 移入系统消息 */
    onMouseenter() {
      // this.isDot = false;
      this.msgListShow = true;
    },
    /** 移出系统消息 */
    onMouseleave() {
      this.msgListShow = false;
    },
    /** 获取未读信息 */
    getOnMsgFun(val) {
      this.noReadMsgList = [];
      // getNoReadMessageAPI().then((res)=>{
      this.noReadMsgList = val;
      if (this.noReadMsgList.length > 0) {
        // this.isDot = true;
      } else {
        this.isDot = false;
      }
      // })
    },
    /** 显示未读标识 */
    changeDotVal() {
      this.isDot = true;
    },
    /** 设置用户信息 */
    setuserInfo(val) {
      this.userData = val;
      console.log(this.userData, 'this.userData');
    },
    /** 菜单移入事件 */
    onMenuMouseenter(index) {
      if (index == 1) {
        this.productShow = true;
      } else if (index == 3) {
        this.aboutShow = true;
      } else {
        return;
      }
      clearTimeout(this.dropDown);
    },
    /** 菜单移出事件 */
    onMenuMouseout() {
      let self = this;
      this.dropDown = setTimeout(function () {
        self.aboutShow = false;
        self.productShow = false;
      }, 100)
    },

    /**  */
    mbOpenMenu() {
      this.isShowMenu = !this.isShowMenu;
    },

    /** 点击跳转首页qz.pz3d.cn */
    handleSelect(index) {
      let href = 'https://qz.pz3d.cn/'
      window.open(href, '_blank');
    }
  },
  mounted() {
    let self = this;
    //这里的ip地址改为自己服务器的ip地址
    // var ws = new WebSocket('ws://192.168.0.23:1234');
    var ws = new WebSocket('wss://' + this.baseName + '/wss');
    ws.onopen = function () {
      setTimeout(() => {
        var uid = localStorage.getItem('userId');
        ws.send(uid);
      }, 500);
    };
    ws.onmessage = function (e) {
      var message_info = JSON.parse(e.data);
      if (message_info.content == "upproject") {
        // console.log(456);
        localStorage.setItem('upproject', 'true');
      }
      self.changeDotVal();
    };
    // this.getOnMsgFun(this.msgList);

    this.menuArray = [
      { name: '首页', path: '#', },
      // {name: '产品服务', path: '', children:[
      //   {name: '3D互动工具', path: ''},
      //   {name: '定制合作', path: ''},
      // ]},
      // {name: '应用案例', path: '',},
      // {name: '关于我们', path: '', children:[
      //   {name: '企业介绍', path: ''},
      //   {name: '行业资讯', path: ''},
      //   {name: '联系我们', path: ''},
      // ]},
    ]
  },
  watch: {
    user_data: {
      immediate: true,
      handler(newVal) {
        setTimeout(() => {
          // if(newVal != null)
          console.log(newVal);
          this.setuserInfo(newVal.info);
        }, 800);
      },
      deep: true,
    },
    msgList: {
      handler(newVal) {
        if (newVal) {
          this.getOnMsgFun(newVal);
        }
      },
      deep: true,
    },
    userMsg: {
      immediate: true,
      handler(newVal) {
        if (newVal == undefined) {
          this.showContact = true;
        } else {
          this.showContact = false;
          // this.setuserInfo(newVal);
        }
      },
      deep: true,
    },
    $route: { // 监听路由
      handler(to, from) {
        this.activeIndex = 'null';
      },
      deep: true,
      immediate: true,
    }
  }
};
</script>